import React from 'react';

import styled from 'styled-components';

import { EUIButtonBaseOpacity } from '@aquariuxfintech/aqx-trader-react-ui/button';
import { ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { rgba } from '@aqx-core/common/theme';

interface IAuthFormSecondaryAction {
  infoText?: string;
  actionText: string;
  onClickActionText: () => void;
  disabled?: boolean;
  dataTestId?: EDataTestId;
}

const AuthFormSecondaryAction: FCC<IAuthFormSecondaryAction> = ({
  infoText,
  actionText,
  onClickActionText,
  disabled,
  dataTestId
}) => {
  const onClick = () => {
    if (disabled) {
      return;
    }
    onClickActionText();
  };

  return (
    <StyledSignUpContainer>
      {infoText && <UIText typography={ETypography.TEXT_L_REGULAR}>{infoText}</UIText>}
      <StyledSignUpTextContainer onClick={onClick} data-testid={dataTestId}>
        <StyledSignUpText typography={ETypography.TEXT_L_REGULAR} $disabled={disabled}>
          {actionText}
        </StyledSignUpText>
      </StyledSignUpTextContainer>
    </StyledSignUpContainer>
  );
};

const StyledSignUpContainer = styled.div`
  gap: 4px;
  display: flex;
  justify-content: center;
`;

const StyledSignUpTextContainer = styled.span``;

const StyledSignUpText = styled(UIText)<{ $disabled?: boolean }>`
  color: ${({ theme, $disabled }) => rgba(theme.themeColors.primary, $disabled ? EUIButtonBaseOpacity.DISABLED : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export default AuthFormSecondaryAction;
